/* eslint-disable */
export default {
  changeByPercent: 'ChangeByPercent',
  changeByAmount: 'ChangeByAmount',
  setAmount: 'SetToAmount',
  excludeBid: 'Set',
  remove: 'Remove',
  noCashback: 'NoCashback'
};

